import {Wifi} from './../models/wifi';
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/semi */
import {Component, NgZone, OnInit} from '@angular/core'
import {ActivatedRoute, Router, NavigationExtras} from '@angular/router'
import {AlertController, LoadingController, MenuController, NavController, Platform} from '@ionic/angular'
import {Car} from 'src/app/models/car.entity'
import {DataService} from '../data.service'
import {Base} from '../models/base'
import {Device} from '../models/device'
import {environment} from 'src/environments/environment';
import {BleClient} from '@capacitor-community/bluetooth-le'
import {User} from '../models/user'
import {Datapackage} from '../models/datapackage';
import {TranslateService} from '@ngx-translate/core';
import {DevicelistPageModule} from './devicelist.module';
import {WifiInfo} from './../models/WifiInfo';
import {Wifis} from '../models/wifis_';

@Component({
  selector: 'app-devicelist',
  templateUrl: './devicelist.page.html',
  styleUrls: ['./devicelist.page.scss'],
})

export class DevicelistPage extends Base implements OnInit {

  public static connectedDevices: string[] = []

  debuglog: string = "-log-" + (new Date())

  user: User

  devices: Device[] = []
  registeredDevices: any[] = []
  registeredDevicesIds: any[] = []
  onboarding: boolean

  page_start: boolean = true
  page_scan: boolean = false

  car: Car
  runScan: boolean
  scanCaption = 'Scan for new devices'

  initial: string = '0'

  private unregisterInProgress = false

  //////////////////COPY BLOCK/////////////////////////

  datapackage: Datapackage = new Datapackage()
  offlinehint: string = ""

  _page = "devicelist"
  _whoAmI = this._page + "Page"

  // eslint-disable-next-line max-len
  constructor(public alertController: AlertController, public translate: TranslateService, private ngZone: NgZone, public platform: Platform, public menu: MenuController, public navController: NavController, public router: Router, public dataService: DataService, private loadingController: LoadingController) {
    super(platform, dataService, router, navController, alertController, menu)
  }

  /**************
   /* Lifecycles
   /*************/

  async ionViewDidEnter() {

    Base.log('[' + this._page + '] ***********************************************')
    Base.log('[' + this._page + '] ************ ' + this._whoAmI + ' *********************')

    Base.nav_push(this._page)
    Base.log(this.datapackage)

    Base.log('[' + this._page + '] **** ' + this._whoAmI + ' * ionViewDidEnter')
    await this.preparePage()
  }

  async ngOnInit() {
  }

  async preparePage() {
    Base.log("[" + this._page + "] prepare devicelistpage")
    this.user = await this.dataService.getUser()
    Base.log(this.user)

    const datapackage = await this.dataService.get('datapackage' + this.user.email)
    Base.log("[" + this._page + "] datapackage retrieved")
    Base.log(datapackage)

    if (datapackage !== null && datapackage !== undefined) {
      Base.log("[" + this._page + "] prepare@" + this._whoAmI + " if " + datapackage.offline)
      this.updateOffline(datapackage.offline)
      this.datapackage = datapackage
      this.car = datapackage.car

      Base.log("[" + this._page + "] prepare@" + this._whoAmI + " with datapackage")
      Base.log(this._whoAmI + "Page ready set up!")
      Base.log("[" + this._page + "] ===================================")

      if (datapackage.initial !== '1') {
        this.page_start = false
        this.page_scan = true
      } else {
        this.page_start = true
        this.page_scan = false
      }

      await this.startPage(datapackage)

    } else {
      Base.log("[" + this._page + "] prepare@" + this._whoAmI + " without datapackage")
      Base.log(this._whoAmI + "Page NOT securely set up, use with caution!")
      Base.log("[" + this._page + "] =X=X=X=X=X=X=X=X=X=X=X=X=X=X=X=X=X=X=X=X=")

      await this.startPage(datapackage)
    }
  }

  //////////////////COPY BLOCK COMPLETE/////////////////////////

  async startPage(datapackage: Datapackage) {

    Base.log("[" + this._page + "] startPage in OFFLINE-mode")
    await this.updateRegisteredValues(datapackage.devices)
    //await this.getRegisteredDevicesFromBackend()

    if (this.isDevice()) {
      await BleClient.initialize({ androidNeverForLocation: true });
      await this.dataService.stopScanning()
    }

  }


  async updateRegisteredValues(registeredDevices: Device[]) {
    const updatedDevices: Device[] = []

    for (let device of registeredDevices) {
      Base.log("[" + this._page + "] device origin")
      Base.log(device)

      device = Device.factory(device)
      Base.log("[" + this._page + "] device-factorized")
      Base.log(device)

      const wifi = await this.dataService.getWifiData(device.id)

      if (wifi !== null && wifi !== undefined) {
        device.wifi = wifi
        if (device.last.wifiSsid.value !== null) {
          device.wifi.lastWifi = device.last.wifiSsid.value
        }
      }
      updatedDevices.push(device)
    }

    this.ngZone.run(() => {
      this.registeredDevices = updatedDevices
    })
  }


  updateOffline(mode: boolean) {
    if (mode === true) {
      this.offlinehint = "border-top: 5px red double;"
    } else {
      this.offlinehint = ""
    }
    this.ngZone.run(() => {
      Base.log("[" + this._page + "] offline@list: " + mode)
      if (this.datapackage !== undefined && this.datapackage !== null) {
        this.datapackage.offline = mode
      }
    })
  }

  public async toUnregisterDevice(dev: Device, datapackage: Datapackage) {
    // Stop row-click / other handlers from firing, if any
    if (this.unregisterInProgress) {
      return
    }

    const message =
      'Deregistering this device will also uninstall it from any vehicle that it is currently attached to and make the device available to be registered again by another user.'

    const alert = await this.alertController.create({
      cssClass: 'basic-alert',
      header: '',
      message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Continue',
          role: 'confirm',
          handler: () => {
            // Use handler to avoid needing to await onDidDismiss
            this.performUnregisterDevice(dev, datapackage)
          },
        },
      ],
    })

    await alert.present()
  }

  private async performUnregisterDevice(dev: Device, datapackage: Datapackage) {
    if (this.unregisterInProgress) {
      return
    }
    this.unregisterInProgress = true

    const loading = await this.loadingController.create({
      message: 'Deregistering device...',
      spinner: 'crescent',
      backdropDismiss: false,
    })

    try {
      await loading.present()

      await this.dataService
        .unregisterDevice(dev)
        .toPromise()

      // No optimistic updates: only update UI after backend confirms success
      await this.removeDeviceFromLocalState(dev)

      // If there are other cached copies, persist the updated datapackage too
      if (this.user?.email) {
        await this.dataService.set('datapackage' + this.user.email, this.datapackage)
      }
    } catch (e) {
      Base.log("[" + this._page + "] unregisterDevice failed")
      Base.log(e)

      await this.presentAlert(
        'Deregister failed',
        '',
        'The device could not be deregistered. Please try again.'
      )
    } finally {
      await loading.dismiss()
      this.unregisterInProgress = false
    }
  }

  private async removeDeviceFromLocalState(dev: Device) {
    // Update datapackage
    if (this.datapackage?.devices?.length) {
      this.datapackage.devices = this.datapackage.devices.filter(d => d?.id !== dev?.id)
    }

    // Update the list shown on screen
    this.ngZone.run(() => {
      this.registeredDevices = (this.registeredDevices || []).filter(d => d?.id !== dev?.id)
    })

    // If we removed the last device, flip UI state to "no devices" page if needed
    if (!this.datapackage?.devices || this.datapackage.devices.length === 0) {
      this.ngZone.run(() => {
        this.page_start = true
        this.page_scan = false
      })
    }
  }


  /**
   * Get the devices registered to me

   async getRegisteredDevicesFromBackend() {

   Base.log("[" + this._page + "] getRegisteredDevicesFromBackend")

   const temp: Device[] = []

   await this.dataService.registereddevices().subscribe((result) => {
   const devices = JSON.parse(JSON.stringify(result))

   devices.forEach(dev => {

   Base.log("[" + this._page + "] getRegisteredDevicesFromBackend for wifi " + dev.id )
   this.dataService.getWifiData(dev.id).then((wifi) => {

   Base.log("[" + this._page + "] getRegisteredDevicesFromBackend intern")
   console.log(dev)

   let device = Device.factory(dev)
   device.label = 'hbg_' + device.id
   device.wifi = wifi

   temp.push(device)
   /*
   device.wifi = ''
   device.label = 'hbg_' + device.id

   device.registered = 'reg'

   this.dataService.get('devicewifis' + device.id).then((cntwifi) => {
   device.cntWifis = cntwifi
   this.dataService.getWifi(device.label).then((wifiname) => {
   device.wifi = wifiname
   })

   temp.push(device)
   })

   })
   this.dataService.set("devices", devices)
   this.updateRegisteredValues(temp)
   })



   })
   }
   */
  /**
   * Get the state of the connection
   * @param dev
   * @returns
   */
  deviceConnected(dev) {
    return DevicelistPage.connectedDevices.includes(dev.label)
  }

  startIt() {
    this.page_scan = !this.page_scan
    this.page_start = !this.page_start
  }


  async startScan() {

    this.debuglog += "startScan" + "\n"


    this.dataService.getUser().then((user) => {
      if (user !== null && user != undefined && user.email.indexOf('@objectix.de') > 0) {
        const dummy = new Device('050-00013', '00:00:00:00:00:13', 'hbg_050-00013', WifiInfo.factory(), '', '')
        this.devices.push(dummy)
        const dummy1 = new Device('050-00006', '00:00:00:00:00:13', 'hbg_050-00006', WifiInfo.factory(), '', '')
        this.devices.push(dummy1)
        const dummy2 = new Device('050-00309', '00:00:00:00:00:13', 'hbg_050-00309', WifiInfo.factory(), '', '')
        this.devices.push(dummy2)
        const dummy3 = new Device('050-00183', '00:00:00:00:00:13', 'hbg_050-00183', WifiInfo.factory(), '', '')
        this.devices.push(dummy3)

        this.updateValues(this.devices)
        this.debuglog += "Dummy devicelist created" + "\n"
      }
    })


    this.runScan = true
    Base.log('[' + this._page + '] Create List')

    this.scan().then((_) => {
      Base.log('[' + this._page + '] Scanning')
      this.dataService.devices.forEach((dev) => {

        //if (!this.registereddevices_ids.includes(dev.label))  {
        this.registeredDevicesIds.push(dev.label)
        Base.log(dev)
        this.debuglog += "Found " + dev.label + "\n"
        //}

      })

    })

  }

  async scan() {

    this.devices = []

    try {
      await BleClient.initialize({ androidNeverForLocation: true });
      Base.log("[" + this._page + "] INITIALIZE BLE")

      await this.dataService.startScanning(
        {
          //services: [BleHelper.WIFI_SERVICE], //[HOOTS_DEVICES],
          namePrefix: 'hbg_'

        }, (result) => {
          //Base.Base('info', 'received new scan result ' + result, this);
          //if (this.devices.filter(e => e.label === result.localName).length > 0) {
          //  //Base.Base('info', result.localName + ' already present', this)
          //} else {
          // //Base.log("[" + this._page + "] device found by scan " + result.device.name)

          if (result != undefined && result.device != undefined && result.device.name != undefined && result.device.name.length > 0) {
            this.debuglog += "device found by scan " + result.device.name + "\n"
            // //Base.log("[" + this._page + "] device add to list: " + result.device.name)

            //Base.log("[" + this._page + "] Get data for " + 'wifi' + result.device.deviceId)
            //this.dataService.get('wifi' + result.device.deviceId).then((nbrWifi) => {
            this.dataService.getWifiData(result.device.deviceId).then((wifiInfo) => {

              this.devices.push(new Device(result.device.name.replace('hbg_', ''), '', result.device.name, wifiInfo, '', ''))
              this.updateValues(this.devices)

            })
          }
          //Base.console('info', result.localName + ' added', this)

          //}
        },
        10000,
        () => {
          Base.log("[" + this._page + "] STOP SCANNING")
          this.runScan = false
        }
      );

    } catch (error) {
      Base.log(error);
      this.runScan = false
    }


  }

  hasWifi(devicename: string) {
    return this.dataService.getWifiData(devicename).then((wifiInfo) => {
      return wifiInfo.count
    })
  }

  async stopScan() {
    //Base.console('info', 'Scan STOPPED')
    this.runScan = false
    this.scanCaption = 'Scan for new devices'
    this.dataService.devices = []
    await this.dataService.stopScanning()
  }


  connectToBTDevice(dev: Device) {
    Base.log("[" + this._page + "] connectToBTDevice")
    this.runScan = false

    setTimeout(async () => {
      //Base.console('info', '***********************************')
      //Base.console('info', 'Connection to ' + dev.label)
      //Base.console('info', dev)
      const device = this.dataService.connectToBTDevice(dev)
      //Base.console('info', device)

      //Base.console('info', '***********************************')
    }, 5000)
  }


  updateValues(devices) {
    this.ngZone.run(() => {
      this.devices = devices
    })
  }

  public back() {
    this.dataService.stopScanning()

    this.navController.navigateForward('/' + Base.nav_pop());
    /*
    this.dataService.get('devicelist_back').then((_) => {
      if (_ !== undefined && _ !== null && _ === 'list') {
        this.toListPage()
      } else if (_ !== undefined && _ !== null && _ === 'onboard') {
        this.toOnboard()
      } else if (_ !== undefined && _ !== null && _ === 'add-car') {
        this.toNewCarPage()
      } else if (_ !== undefined && _ !== null && _ === 'edit') {

        // //Base.log('[' + this._page + '] wie genau?')
      } else {
        this.toListPage()
      }
    })
    */
  }


  toNewCarPage() {
    this.dataService.set('add-car-back', 'devicelist').then(() => {
      this.navController.navigateForward(['/' + Base.nav_pop()])
    })
  }


  public toListPage() {
    this.navController.navigateForward(['/' + Base.nav_pop()])
  }

}
